import React from 'react'
import LeftBar from '../../leftbar/LeftBar'
import PageTitle from '../../pagetitle/PageTitle'

export default function Katalog() {
  return (
    <>
      <PageTitle name="Katalog"></PageTitle>
      <div class="container">
        <div class="singlePost my-4">
          <div class="row">
            <div class="col-md-9">
              <div class="post sponsor">
                <div class="column">
                  <a href="https://okafkatalog.samsun.edu.tr" target="_blank">
                    <h3 class="standart">Kataloğu Aç</h3>
                  </a>
                  
                </div>
                <div class="column">
                  <a href="/okafKatalog1.pdf" target="_blank">
                    <h3 class="altin">Kataloğu İndir</h3>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <LeftBar />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
